
const digest = 'afe2576166458f7cfae475482211c7f901165195a3950c51c320a80ae93586ae';
const classes = {"wrapper":"_wrapper_14amn_1","items":"_items_14amn_8","button":"_button_14amn_14"};
const css = `._wrapper_14amn_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 20px;
}

._items_14amn_8 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

._button_14amn_14 {
  display: flex;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  